// extracted by mini-css-extract-plugin
module.exports = {"container":"BenefitsTile_container__vvh7d","image":"BenefitsTile_image__eAQmm","heading":"BenefitsTile_heading__wqmN7","text":"BenefitsTile_text__rBH9v"};